<template>
  <div>
    <div v-if="$route.meta.psicossocialPreenchimento" class="psicossocial-header primary">
      <ProgressCircular
        v-if="$route.meta.progressCircular"
        :value="porcentagemRespostasPsicossocial"
        text="Progresso"
      />
      <v-btn icon dark @click="$router.push('/psicossocial')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <router-view />
  </div>
</template>

<script>
import ProgressCircular from '@/core/components/ProgressCircular'
import porcentagemRespostasPsicossocial from '@/core/mixins/porcentagemRespostasPsicossocial'

export default {
  components: { ProgressCircular },
  mixins: [porcentagemRespostasPsicossocial]
}
</script>

<style scoped>
.psicossocial-header {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 16px;
  height: 56px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.psicossocial-header ::v-deep div {
  color: white;
}
</style>
